<template>
    <div class="loginpage">
        <div class="login-box" v-bind:class="{ changewidth: isActive }">
            <img src="../assets/images/login/logopaybay.png">
            <p class="login-title" style="font-size: 32px;">数字标牌</p>
          <!--  <div class="login-box-body" >-->
              <el-form :model="loginForm" :rules="rules2" ref="loginForm"  class="demo-ruleForm"  v-loading="loginload"  element-loading-text="正在登陆，请稍后。。。">
                    <!--<el-form-item prop="name" class="form-group has-feedback">
                        <el-input type="text" size="large" v-model="loginForm.name" auto-complete="off" placeholder="请输入用户名！">
                        </el-input>
                    </el-form-item >
                    <el-form-item prop="password" class="form-group has-feedback">
                        <el-input type="password" size="large" v-model="loginForm.password" auto-complete="off" placeholder="请输入密码！"></el-input>
                    </el-form-item>
                    &lt;!&ndash;<el-form-item prop="checkPass" class="form-group has-feedback">&ndash;&gt;
                        &lt;!&ndash;<el-input class="checklog" type="text" size="large" v-model="loginForm.checkPass" auto-complete="off" placeholder="请输入验证码！"></el-input>&ndash;&gt;
                        &lt;!&ndash;<el-button type="info" class="right showBtn" @click="createCode()"  >{{checkPwd}}</el-button>&ndash;&gt;
                    &lt;!&ndash;</el-form-item>&ndash;&gt;
                    <el-form-item class="form-group has-feedback submitlog">
                        <el-button type="primary" :plain="true" @click="submitForm('loginForm')" :loading="loginload" class="showBtn">提交</el-button>
                        <el-button @click="resetForm('loginForm')" class="showBtn">重置</el-button>
                    </el-form-item>-->
                </el-form>
           <!-- </div>-->
        </div>
    </div>
</template>

<script>
    //*********2-20 修改
   /* import secret from '../assets/js/jsencrypt.min'*/

    //**********end
   // import secret from '../assets/js/jsencrypt.min'

    export default {
        created(){

           // this.createCode();
            if(this.$route.params!=null){

                this.loginForm.wcUserId=this.$route.params.wcUserId
                this.loginForm.timestamp=this.$route.params.timestamp
                this.loginForm.sign=this.$route.params.sign
                this.autologin()
            }
        },
        mounted () {
            const that = this;
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.screenWidth = window.screenWidth
                })()
            }
        },
        data() {
            var validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入用户名！'));
                } else {
                    if (this.loginForm.password !== '') {
                        this.$refs.loginForm.validateField('password');
                    }
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码！'));
                }else {
                    callback();
                }
            };
//            var validateCheckpass = (rule, value, callback) => {
//                if (value === '') {
//                    callback(new Error('请输入验证码！'));
//                }else if(value.toUpperCase()!==this.checkPwd.toUpperCase()){
//                    callback(new Error('验证码错误，可点击重新获取'));
//                    this.loginload=false;
//                }
//                else {
//                    callback();
//                }
//            };

            return {
                screenWidth: document.body.clientWidth,
                isActive:true,
                loginForm: {
                    wcUserId: '',
                    timestamp: '',
                    sign:'',
                },

                loginload:true,
                checkPwd:'12345',
                rules2: {
                    name: [
                        { validator: validateName, trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePass, trigger: 'blur' },
                    ]
//                    checkPass: [
//                        { validator: validateCheckpass, trigger: 'blur' }
//                    ]
                }
            };
        },
        methods: {
            autologin() {

                        var _this=this;
                       // var encrypt =new encrypt.JSEncrypt();

                debugger
                        this.$http.post(this.requetHost+'/sys/user/wclogin', {
                            wcUserId:this.loginForm.wcUserId,timestamp:this.loginForm.timestamp,sign:this.loginForm.sign})
                            .then(response => {
                                    if (response.status === 200) {
                                        debugger
                                        //var data = response.body;
                                        if ( response.body.status == "200") {
                                            //缓存用户Js
                                            this.savecookie("user_token",  response.body.user_token, 30);
                                            this.savecookie("wcLogin", 1, 30);
                                            this.savecookie("access_id",  response.body.access_id, 30);
                                            this.savecookie("username_client",  response.body.username, 30);
                                                this.$router.push('/main');


                                        }else{
                                            this.$message({
                                                showClose: true,
                                                message: ''+response.body.msg,
                                                type: 'error'

                                            });
                                        }
                                        this.loginload=false;
                                    }
                                },function(response){
                                    this.$message({
                                        showClose: true,
                                        message: '网络异常',
                                        type: 'error'

                                    });
                                    this.loginload=false;
                                }
                            )
                        //*********2-20 修改
//                        this.$store.dispatch('login', {username:this.loginForm.name,password:this.loginForm.password}).then(() => {
//                                // new Base().savecookie("username",data.username,30);
//                        });

            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            createCode(){
                var code="";
                var codeLength = 4;//验证码的长度
                var selectChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                    'a','b','c','d','e','f','g','h','i','j','k','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
                    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');//所有候选组成验证码的字符，当然也可以用中文的
                for (var i = 0; i < codeLength; i++) {
                    var charIndex = Math.floor(Math.random() * 52);
                    code+= selectChar[charIndex];
                }
                this.checkPwd=code;
            }
        },
        watch: {
            screenWidth (val) {
                this.screenWidth = val
                if (this.screenWidth > 769) {
                    this.isActive = true;
                } else {
                    this.isActive = false;
                }
            }
        },
        route: {
            activate (transition) {
            }
        }
        /*优化 因为 频繁 触发 resize 函数，导致页面很卡的 问题*/
        /* watch: {
         screenWidth (val) {
         if (!this.timer) {
         this.screenWidth = val
         this.timer = true
         let that = this
         setTimeout(function () {
         // that.screenWidth = that.$store.state.canvasWidth
         console.log(that.screenWidth)
         if(that.screenWidth>769) {
         console.log("缩小啦")
         }
         that.init();
         that.timer = false
         }, 400)
         }
         }
         }*/
    }
</script>
<style>
    /*@import url('../assets/css/bootstrap.min.css');*/

    .loginpage{
        position: absolute;
        width: 100%;
        height: 100%;
        font-family: Helvetica, sans-serif;
        text-align: center;
        background-image:url("../assets/loginin_bg.jpg");
        background-repeat: no-repeat;
        background-size:cover;
    }
    .login-box{
        /*opacity:0.9;*/
        background-color: #fff;
        /*filter:alpha(opacity=90);*/
        /*color:black;*/
        width: 412px;
        height: 442px;
        /*margin: 6% auto;*/
        margin: 10% 0 0 55%;
        /*padding-top: 20px;*/
        border-radius:5px;
        border:6px solid;
        border:6px solid rgb(255,255,255,0.3);
    }
    .changewidth{
        width: 450px;
    }
    .login-box-body{
        margin-top: 60px;
        background: #fff;
        padding: 0 20px;
    }
    .login-title{
        /*line-height: 80px;*/
        font-size: 30px;
        /*font-weight: 200;*/
        color: #757575;
        /*text-shadow: 0 1px 4px rgba(0,0,0,.2);*/
        /*background-image:url("../assets/images/login/flowle.png");*/
        /*background-repeat: no-repeat;*/
        /*background-size:100%,100%;*/
    }
    .demo-ruleForm{
        position: relative;
       /* text-align: center;*/
        margin: 15px auto 0 auto;
    }
    /*input{*/
        /*margin-top: 10px;*/
    /*}*/
    .right{
        width: 35%;
        padding-top: 10px;
        line-height: 20px;
        float: right;
        font-size: 20px;
    }
    .checklog{
        width: 60%;
        float: left;
    }
    .submitlog{
        text-align: center;
    }
    .prepend-input-span{
        width:10px;
        background-color:#29b0b8;
    }
    @import "../assets/css/button.css";
</style>


// WEBPACK FOOTER //
// wcLogin.vue?3ac2bd30